<template>
  <div id="transportContract" v-loading="loading">
    <div class="buttons" v-loading="loading">
      <el-button
        type="primary"
        icon="el-icon-plus"
        @click="PrintContractD"
        style="margin: 10px 0"
        >打印 </el-button
      ><el-button
        type="primary"
        icon="el-icon-plus"
        @click="saveContractA"
        style="margin: 10px 10px"
        v-if="dialogForm.approveStatus != 3 && dialogForm.approveStatus != 2"
        >保存
      </el-button>
      <el-button type="primary" @click="setWatermark" style="margin: 10px 0"
        >设置水印
      </el-button>
      <div style="display: inline-flex; width: 300px;margin-left:150px;">
        <el-input v-model="inputPages" placeholder="总页数" style="margin-left: 10px;"></el-input>
        <el-input v-model="inputHeight" placeholder="单页高" style="margin-left: 10px;"></el-input>
        <el-input v-model="inputPosx" placeholder="偏移量" style="margin-left: 10px;"></el-input>
      </div>
    </div>
    <div ref="HTMLtransportContent" id="HTMLtransportContent" :key="printClass" :class="printClass">
      <div class="HTMLtransportContract1">
        <div style="position: relative;">
        <p
          class="contract_word_p"
          style="margin-bottom: 0;font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: center"
        >
          <span style="font-size: 20px; font-family: 宋体; color: red"></span
          ><span style="font-size: 20px; font-family: 宋体; color: red"></span
          ><span style="font-size: 40px; font-family: 宋体; color: red"
            >青岛路桥建设集团有限公司</span
          >
        </p>
        <p
          class="contract_word_p"
          style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: right"
        >
          <span
            style="
              position: absolute;
              z-index: 8;
              left: 10px;
              top: 2px;
              width: 44px;
              height: 57px;
            "
            ><img
              width="44"
              height="57"
              src="@/assets/images/subContract/LaborContract/logo.png"
              alt="路桥logo"
          /></span>
        </p>
        </div>
        <hr style="margin-top: 0" />
        <p style="text-align: center; line-height: 35px"></p>
        <p style="text-align: center; line-height: 31px">
          <strong
            ><span style="font-family: 黑体; font-size: 24px"
              >拌合料运输合同</span
            ></strong
          >
        </p>
        <p style="line-height: 31px">
          <span style="font-family: 楷体_GB2312; font-size: 19px"
            >合同编号：<span
              style="
                border-bottom: 1px solid rgb(44, 62, 80);
                outline: 0;
                text-indent: 5px;
                display: inline-block;
                min-width: 400px;
              "
              :contenteditable="dialogForm.approveStatus != 2&&dialogForm.approveStatus != 3"
              class="serialNumber"
              >{{
                detailForm.serialNumber ||"QDLQ-"
              }}</span
            >
          </span>
        </p>
        <p style="line-height: 31px">
          <span style="font-family: 楷体_GB2312; font-size: 19px"
            >签订时间：<span
              style="
                border-bottom: 1px solid rgb(44, 62, 80);
                outline: 0;
                text-indent: 5px;
                display: inline-block;
                min-width: 400px;
              "
              :contenteditable="dialogForm.approveStatus != 2&&dialogForm.approveStatus != 3"
              class="signDate"
              >{{ detailForm.signDate ? detailForm.signDate : "" }}</span
            ></span
          >
        </p>
        <p style="line-height: 31px">
          <span style="font-family: 楷体_GB2312; font-size: 19px"
            >签约地点：<span
              style="
                border-bottom: 1px solid rgb(44, 62, 80);
                outline: 0;
                text-indent: 5px;
                display: inline-block;
                min-width: 400px;
              "
              :contenteditable="dialogForm.approveStatus != 2&&dialogForm.approveStatus != 3"
              class="signPlace"
              >{{ detailForm.signPlace || "青岛市" }}</span
            ></span
          >
        </p>
        <p style="line-height: 31px">
          <span style="font-family: 楷体_GB2312; font-size: 19px"
            >甲方：&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span
              style="
                border-bottom: 1px solid rgb(44, 62, 80);
                outline: 0;
                text-indent: 5px;
                display: inline-block;
                min-width: 400px;
              "
              :contenteditable="dialogForm.approveStatus != 2&&dialogForm.approveStatus != 3"
              class="partyA"
              >{{ detailForm.partyA || "青岛路桥建设集团有限公司" }}</span
            ></span
          >
        </p>
        <p style="line-height: 31px">
          <span style="font-family: 楷体_GB2312; font-size: 19px"
            >乙方：&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <span
              style="
                border-bottom: 1px solid rgb(44, 62, 80);
                outline: 0;
                text-indent: 5px;
                display: inline-block;
                min-width: 400px;
              "
              :contenteditable="dialogForm.approveStatus != 2&&dialogForm.approveStatus != 3"
              class="partyB"
              >{{ detailForm.partyB ? detailForm.partyB : "" }}</span
            ></span
          >
        </p>
        <p style="text-indent: 37px; line-height: 31px">
          <span style="font-family: 楷体_GB2312; font-size: 19px"
            >根据《中华人民共和国民法典》及有关法律法规的规定，遵循平等、自愿和诚实信用的原则，双方就
            <span
              style="
                border-bottom: 1px solid rgb(44, 62, 80);
                outline: 0;
                min-width: 4cm;
                display: inline-block;
                text-indent: 5px;
              "
              :contenteditable="dialogForm.approveStatus != 2&&dialogForm.approveStatus != 3"
              class="project"
              >{{ detailForm.project || "" }}</span
            >工程<span
              style="
                border-bottom: 1px solid rgb(44, 62, 80);
                outline: 0;
                min-width: 6cm;
                display: inline-block;
                text-indent: 5px;
              "
              :contenteditable="dialogForm.approveStatus != 2&&dialogForm.approveStatus != 3"
              class="projectName"
              >{{ detailForm.projectName || "" }}</span
            >的运输事项协商一致，根据各工程的具体情况，订立以下合同条款：</span
          >
        </p>
        <p style="text-indent: 37px; line-height: 31px">
          <span style="font-family: 楷体_GB2312; font-size: 19px"
            >一、工作内容</span
          >
        </p>
        <p style="text-indent: 37px; line-height: 31px">
          <span style="font-family: 楷体_GB2312; font-size: 19px"
            >乙方根据甲方施工需要及要求，将<span
              style="
                border-bottom: 1px solid rgb(44, 62, 80);
                outline: 0;
                text-indent: 5px;
                display: inline-block;
                min-width: 240px;
              "
              :contenteditable="dialogForm.approveStatus != 2&&dialogForm.approveStatus != 3"
              class="contents"
              >{{ detailForm.contents }}</span
            >运送至甲方指定的地点。</span
          >
        </p>
        <p style="text-indent: 37px; line-height: 31px">
          <span style="font-family: 楷体_GB2312; font-size: 19px">二、</span
          ><span style="font-family: 楷体_GB2312; font-size: 19px"
            >合同期限：<span
              style="
                border-bottom: 1px solid rgb(44, 62, 80);
                outline: 0;
                text-indent: 5px;
                display: inline-block;
                min-width: 180px;
              "
              :contenteditable="dialogForm.approveStatus != 2&&dialogForm.approveStatus != 3"
              class="limitDate"
              >{{ detailForm.limitDate }}</span
            >。</span>
        </p>
        <p style="text-indent: 37px; line-height: 31px">
          <span style="font-family: 楷体_GB2312; font-size: 19px">三</span
          ><span style="font-family: 楷体_GB2312; font-size: 19px"
            >、综合单价</span
          >
        </p>
        <p style="text-indent: 37px; line-height: 31px">
          <span style="font-family: 楷体_GB2312; font-size: 19px">1</span
          ><span style="font-family: 楷体_GB2312; font-size: 19px"
            >、路面基层及垫层拌合料运输：</span
          >
        </p>
        <p style="text-indent: 37px; line-height: 31px">
          <span style="font-family: 楷体_GB2312; font-size: 19px">（</span
          ><span style="font-family: 楷体_GB2312; font-size: 19px">1</span
          ><span style="font-family: 楷体_GB2312; font-size: 19px">）</span
          ><span style="font-family: 楷体_GB2312; font-size: 19px"
            ><span style="font-family: 楷体_GB2312">、运距</span
            ><span style="font-family: 楷体_GB2312"
              >1-5km内（含5km），运输单价<span
              style="
                border-bottom: 1px solid rgb(44, 62, 80);
                outline: 0;
                text-indent: 5px;
                display: inline-block;
                min-width: 40px;
              "
              :contenteditable="dialogForm.approveStatus != 2&&dialogForm.approveStatus != 3"
              class="price1"
              >{{ detailForm.price1 }}</span
            >元</span
            ><span style="font-family: 楷体_GB2312">/t。</span></span
          >
        </p>
        <p style="text-indent: 37px; line-height: 31px">
          <span style="font-family: 楷体_GB2312; font-size: 19px">（</span
          ><span style="font-family: 楷体_GB2312; font-size: 19px">2</span
          ><span style="font-family: 楷体_GB2312; font-size: 19px">）</span
          ><span style="font-family: 楷体_GB2312; font-size: 19px"
            ><span style="font-family: 楷体_GB2312">、运距</span
            ><span style="font-family: 楷体_GB2312"
              >5-10km内（含10km），第一个5km运输单价<span
              style="
                border-bottom: 1px solid rgb(44, 62, 80);
                outline: 0;
                text-indent: 5px;
                display: inline-block;
                min-width: 40px;
              "
              :contenteditable="dialogForm.approveStatus != 2&&dialogForm.approveStatus != 3"
              class="price2"
              >{{ detailForm.price2 }}</span
            >元/t，每增运1km运输单价<span
              style="
                border-bottom: 1px solid rgb(44, 62, 80);
                outline: 0;
                text-indent: 5px;
                display: inline-block;
                min-width: 40px;
              "
              :contenteditable="dialogForm.approveStatus != 2&&dialogForm.approveStatus != 3"
              class="price3"
              >{{ detailForm.price3 }}</span
            >元/t。 &nbsp;&nbsp;</span
            ></span
          >
        </p>
        <p style="text-indent: 37px; line-height: 31px">
          <span style="font-family: 楷体_GB2312; font-size: 19px">
            （3）、运距10-20km内（含20km），前10km按第2条执行，之后每增运1km运输单价<span
              style="
                border-bottom: 1px solid rgb(44, 62, 80);
                outline: 0;
                text-indent: 5px;
                display: inline-block;
                min-width: 40px;
              "
              :contenteditable="dialogForm.approveStatus != 2&&dialogForm.approveStatus != 3"
              class="price4"
              >{{ detailForm.price4 }}</span
            >元/t。</span>
        </p>
        <p style="text-indent: 37px; line-height: 31px">
          <span style="font-family: 楷体_GB2312; font-size: 19px">（4）、运距20km以上，前20km按第3条执行，之后每增运1km运输单价
            <span
              style="
                border-bottom: 1px solid rgb(44, 62, 80);
                outline: 0;
                text-indent: 5px;
                display: inline-block;
                min-width: 40px;
              "
              :contenteditable="dialogForm.approveStatus != 2&&dialogForm.approveStatus != 3"
              class="price5"
              >{{ detailForm.price5 }}</span
            >元/t。</span>
        </p>
        <p style="text-indent: 37px; line-height: 31px">
          <span style="font-family: 楷体_GB2312; font-size: 19px">2</span
          ><span style="font-family: 楷体_GB2312; font-size: 19px"
            >、路面面层沥青混凝土拌合料运输：</span
          >
        </p>
        <p style="text-indent: 37px; line-height: 31px">
          <span style="font-family: 楷体_GB2312; font-size: 19px">（</span
          ><span style="font-family: 楷体_GB2312; font-size: 19px">1</span
          ><span style="font-family: 楷体_GB2312; font-size: 19px">）</span
          ><span style="font-family: 楷体_GB2312; font-size: 19px"
            ><span style="font-family: 楷体_GB2312">、运距</span
            ><span style="font-family: 楷体_GB2312"
              >1-5km内（含5km），运输单价<span
              style="
                border-bottom: 1px solid rgb(44, 62, 80);
                outline: 0;
                text-indent: 5px;
                display: inline-block;
                min-width: 40px;
              "
              :contenteditable="dialogForm.approveStatus != 2&&dialogForm.approveStatus != 3"
              class="price6"
              >{{ detailForm.price6 }}</span
            >元/t。</span></span
          >
        </p>
        <p style="text-indent: 37px; line-height: 31px">
          <span style="font-family: 楷体_GB2312; font-size: 19px">（</span
          ><span style="font-family: 楷体_GB2312; font-size: 19px">2</span
          ><span style="font-family: 楷体_GB2312; font-size: 19px">）</span
          ><span style="font-family: 楷体_GB2312; font-size: 19px"
            ><span style="font-family: 楷体_GB2312">、运距</span
            ><span style="font-family: 楷体_GB2312"
              >5-10km内（含10km），第一个5km运输单价<span
              style="
                border-bottom: 1px solid rgb(44, 62, 80);
                outline: 0;
                text-indent: 5px;
                display: inline-block;
                min-width: 40px;
              "
              :contenteditable="dialogForm.approveStatus != 2&&dialogForm.approveStatus != 3"
              class="price7"
              >{{ detailForm.price7 }}</span
            >元/t，每增运1km运输单价<span
              style="
                border-bottom: 1px solid rgb(44, 62, 80);
                outline: 0;
                text-indent: 5px;
                display: inline-block;
                min-width: 40px;
              "
              :contenteditable="dialogForm.approveStatus != 2&&dialogForm.approveStatus != 3"
              class="price8"
              >{{ detailForm.price8 }}</span
            >元/t。 &nbsp;&nbsp;&nbsp;&nbsp;</span
            ></span
          >
        </p>
        <p style="text-indent: 37px; line-height: 31px">
          <span style="font-family: 楷体_GB2312; font-size: 19px">（</span
          ><span style="font-family: 楷体_GB2312; font-size: 19px">3</span
          ><span style="font-family: 楷体_GB2312; font-size: 19px">）</span
          ><span style="font-family: 楷体_GB2312; font-size: 19px"
            ><span style="font-family: 楷体_GB2312">、运距</span
            ><span style="font-family: 楷体_GB2312"
              >10-20km内（含20km），前10km按第2条执行，之后每增运1km运输单价<<span
              style="
                border-bottom: 1px solid rgb(44, 62, 80);
                outline: 0;
                text-indent: 5px;
                display: inline-block;
                min-width: 40px;
              "
              :contenteditable="dialogForm.approveStatus != 2&&dialogForm.approveStatus != 3"
              class="price9"
              >{{ detailForm.price9 }}</span
            >元/t。</span></span
          >
        </p>
        <p style="text-indent: 37px; line-height: 31px">
          <span style="font-family: 楷体_GB2312; font-size: 19px">（</span
          ><span style="font-family: 楷体_GB2312; font-size: 19px">4</span
          ><span style="font-family: 楷体_GB2312; font-size: 19px">）</span
          ><span style="font-family: 楷体_GB2312; font-size: 19px"
            ><span style="font-family: 楷体_GB2312">、运距</span
            ><span style="font-family: 楷体_GB2312"
              >20km以上，前20km按第3条执行，之后每增运1km运输单价<span
              style="
                border-bottom: 1px solid rgb(44, 62, 80);
                outline: 0;
                text-indent: 5px;
                display: inline-block;
                min-width: 40px;
              "
              :contenteditable="dialogForm.approveStatus != 2&&dialogForm.approveStatus != 3"
              class="price10"
              >{{ detailForm.price10 }}</span
            >元/t。</span></span
          >
        </p>
        <p style="text-indent: 37px; line-height: 31px">
          <span style="font-family: 楷体_GB2312; font-size: 19px"
            ><span style="font-family: 楷体_GB2312"
              >此综合单价包括人工费、机械费、水费、电费、协调费、设备维修保养费、管理费、拌合料覆盖费、税金和计划利润等</span
            ><span style="font-family: 楷体_GB2312"
              >,以及与之相关的所用费用</span
            ></span
          ><span style="font-family: 楷体_GB2312; font-size: 19px">，</span
          ><span style="font-family: 楷体_GB2312; font-size: 19px"
            >甲方不再另行支付任何费用</span
          ><span style="font-family: 楷体_GB2312; font-size: 19px"
            >。此综合单价在协议期间不得调整。</span
          >
        </p>
        <p style="text-indent: 37px; line-height: 31px">
          <span style="font-family: 楷体_GB2312; font-size: 19px"
            >不含税单价固定不变，税金随着国家规定税率的调整而调整，最终税金金额以开具发票时的国家税率计算为准。</span
            >
        </p>
        <p style="text-indent: 37px; line-height: 31px">
          <span style="font-family: 楷体_GB2312; font-size: 19px"
            >三、工程数量的确认</span
          >
        </p>
        <p style="text-indent: 37px; line-height: 31px">
          <span style="font-family: 楷体_GB2312; font-size: 19px"
            >1、在拌合料运输前，需对各计量秤进行核查。经双方联合确认，确定最终结算运距。</span
          >
        </p>
        <p style="text-indent: 37px; line-height: 31px">
          <span style="font-family: 楷体_GB2312; font-size: 19px"
            >2、在拌合料运输途中，每车拌合料都需有发货单，上面应明确注明车号、车次、数量和时间。</span
          >
        </p>
        <p style="text-indent: 37px; line-height: 31px">
          <span style="font-family: 楷体_GB2312; font-size: 19px"
            >3、拌合料到达甲方施工现场后，需甲、乙双方签字确认数量，并记录好时间，甲乙双方应每工班次核对拌合料数量，并以此作为结算依据。</span
          >
        </p>
        <p style="text-indent: 37px; line-height: 31px">
          <span style="font-family: 楷体_GB2312; font-size: 19px"
            >四、结算及付款方式</span
          >
        </p>
        <p style="text-indent: 37px; line-height: 31px">
          <span style="font-family: 楷体_GB2312; font-size: 19px"
            >1、甲乙双方每月核对拌合料数量，以双方共同核定的拌合料数量办理结算。</span
          >
        </p>
        <p style="text-indent: 37px; line-height: 31px">
          <span style="font-family: 楷体_GB2312; font-size: 19px"
            >2、双方本着风险共担，利益共享的原则，一致同意运输价款均应在业主已支付工程计量款的前提下按比例支付，以转账支票或电子汇票的方式付款，不以现金方式支付。</span
          >
        </p>
        <p style="text-indent: 37px; line-height: 31px">
          <span style="font-family: 楷体_GB2312; font-size: 19px">3、</span
          ><span style="font-family: 楷体_GB2312; font-size: 19px">乙方</span
          ><span style="font-family: 楷体_GB2312; font-size: 19px"
            >必须指派专人到</span
          ><span style="font-family: 楷体_GB2312; font-size: 19px">甲方</span
          ><span style="font-family: 楷体_GB2312; font-size: 19px"
            ><span style="font-family: 楷体_GB2312">收款</span
            ><span style="font-family: 楷体_GB2312">,</span></span
          ><span style="font-family: 楷体_GB2312; font-size: 19px"
            >同时收款前应向甲方出具（符合路桥集团财务部要求的）合格的等额发票（</span
          ><span style="text-decoration: underline"
            ><span style="font-family: 楷体_GB2312; font-size: 19px"
              >&nbsp;&nbsp;&nbsp;&nbsp;</span
            ></span
          ><span style="font-family: 楷体_GB2312; font-size: 19px"
            >增值税专用发票）否则</span
          ><span style="font-family: 楷体_GB2312; font-size: 19px">甲方</span
          ><span style="font-family: 楷体_GB2312; font-size: 19px"
            >有权拒绝付款直至</span
          ><span style="font-family: 楷体_GB2312; font-size: 19px">乙方</span
          ><span style="font-family: 楷体_GB2312; font-size: 19px"
            >提供合格发票，（税率以</span
          ><span style="font-family: 楷体_GB2312; font-size: 19px">乙方</span
          ><span style="font-family: 楷体_GB2312; font-size: 19px"
            >开具发票时国家规定税率为准，税金随着税率调整而调整）。</span
          ><span style="font-family: 楷体_GB2312; font-size: 19px">并</span
          ><span style="font-family: 楷体_GB2312; font-size: 19px">乙方</span
          ><span style="font-family: 楷体_GB2312; font-size: 19px"
            >指派的专人应在第一次收取款项时，必须持与本合同</span
          ><span style="font-family: 楷体_GB2312; font-size: 19px">乙方</span
          ><span style="font-family: 楷体_GB2312; font-size: 19px"
            >单位名称一致的授权收款委托书交</span
          ><span style="font-family: 楷体_GB2312; font-size: 19px">甲方</span
          ><span style="font-family: 楷体_GB2312; font-size: 19px"
            >财务备案；如被授权收款人有变动，则由</span
          ><span style="font-family: 楷体_GB2312; font-size: 19px">乙方</span
          ><span style="font-family: 楷体_GB2312; font-size: 19px"
            >单位重新开具变更授权收款委托书交</span
          ><span style="font-family: 楷体_GB2312; font-size: 19px">甲方</span
          ><span style="font-family: 楷体_GB2312; font-size: 19px"
            >财务备案，否则，</span
          ><span style="font-family: 楷体_GB2312; font-size: 19px">甲方</span
          ><span style="font-family: 楷体_GB2312; font-size: 19px"
            ><span style="font-family: 楷体_GB2312">不予付款。</span>
          </span>
        </p>
        <p style="text-indent: 37px; line-height: 31px">
          <span style="font-family: 楷体_GB2312; font-size: 19px">五</span
          ><span style="font-family: 楷体_GB2312; font-size: 19px">、</span
          ><span style="font-family: 楷体_GB2312; font-size: 19px"
            >甲、乙双方的责任与义务：</span
          >
        </p>
        <p style="text-indent: 37px; line-height: 31px">
          <span style="font-family: 楷体_GB2312; font-size: 19px"
            >&nbsp;<span style="font-family: 楷体_GB2312"
              >1、乙方运输车辆进入施工现场后，必须服从甲方施工管理人员调度与指挥，乙方应遵守甲方施工现场的规章制度。</span
            ></span
          >
        </p>
        <p style="text-indent: 37px; line-height: 31px">
          <span style="font-family: 楷体_GB2312; font-size: 19px"
            >2、乙方如发生行车事故（装卸料及运输途中）或其它安全责任事故，其责任和一切经济损失均由乙方承担。如给甲方造成经济损失的，应当承担所有赔偿责任。</span
          >
        </p>
        <p style="text-indent: 37px; line-height: 31px">
          <span style="font-family: 楷体_GB2312; font-size: 19px"
            >3、乙方车辆必须按指定路线把材料运到指定地点，中途不准变卖、倾倒，根据需要加盖苫布，由乙方负责，甲方不额外增加费用。行车途中车辆发生故障要及时抢修，并报告甲方负责人，因乙方原因造成混合料凝固、报废的，将给予5000元以上罚款，报废材料按材料单价折算，在运费中扣除。</span
          >
        </p>
        <p style="text-indent: 37px; line-height: 31px">
          <span style="font-family: 楷体_GB2312; font-size: 19px"
            >4、运输车辆接料时，须服从操作员指挥，并根据生产量适当增减车辆。并保证在限定时间内到达工地。以工地现场负责人签字的过磅单为准。</span
          >
        </p>
        <p style="text-indent: 37px; line-height: 31px">
          <span style="font-family: 楷体_GB2312; font-size: 19px"
            >5、乙方根据甲方要求及时调度车辆，所有车辆须证照、保险齐全，车况良好，乙方车辆在运料过程中与地方关系的协调（当地居民、交警、城管等）以及所发生的任何费用均由乙方自己负责协调及承担。因车辆原因造成甲方不能准时出料施工，影响甲方生产，造成的相应经济损失由乙方承担。</span
          >
        </p>
        <p style="text-indent: 37px; line-height: 31px">
          <span style="font-family: 楷体_GB2312; font-size: 19px"
            >6、乙方车辆进场、退场、住房、各种临时设施及水电等事项由乙方自行解决。</span
          >
        </p>
        <p style="text-indent: 37px; line-height: 31px">
          <span style="font-family: 楷体_GB2312; font-size: 19px"
            >7、乙方车辆司机必须服从管理，听从指挥，装卸拌合料要依次排队，行车中遵守交通规则，严禁酒后开车、超速行驶，做到文明礼貌，优质服务。</span
          >
        </p>
        <p style="text-indent: 37px; line-height: 31px">
          <span style="font-family: 楷体_GB2312; font-size: 19px"
            >8、在合同期限内，乙方不得以任何理由要求甲方提高运费，凡消极怠工无理取闹的，按违约处理，并扣除所有运输费作为罚金。</span
          >
        </p>
        <p style="text-indent: 37px; line-height: 31px">
          <span style="font-family: 楷体_GB2312; font-size: 19px"
            >9、乙方需做好安全防护工作，司机必须在上岗前进行安全教育或安全交底。</span
          >
        </p>
        <p style="text-indent: 37px; line-height: 31px">
          <span style="font-family: 楷体_GB2312; font-size: 19px"
            >10、乙方在运输过程中不得超载，必须遵守各项交通法规；对物料按规定进行遮盖，不得撒漏，必须遵守国家及地方政府环境保护相关法律法规，所有费用由乙方自行承担。</span
          >
        </p>
        <p style="text-indent: 37px; line-height: 31px">
          <span style="font-family: 楷体_GB2312; font-size: 19px"
            >11、乙方应运输过程中，运输车辆经过的沿线村民、商户等个人或群体向甲方或乙方提出赔偿或其他要求，由乙方负责协调处理，产生的一切费用由乙方承担。否则，甲方有权从运输费用中扣除相应费用。</span
          >
        </p>
        <p style="text-indent: 37px; line-height: 31px">
          <span style="font-family: 楷体_GB2312; font-size: 19px">12、</span
          ><span style="font-family: 楷体_GB2312; font-size: 19px"
            >非经甲方书面许可，乙方不得将该</span
          ><span style="font-family: 楷体_GB2312; font-size: 19px"
            >合同项下的</span
          ><span style="font-family: 楷体_GB2312; font-size: 19px">材</span
          ><span style="font-family: 楷体_GB2312; font-size: 19px"
            >料运输工作</span
          ><span style="font-family: 楷体_GB2312; font-size: 19px"
            >转交由第三方承办。</span
          >
        </p>
        <p style="text-indent: 37px; line-height: 31px">
          <span style="font-family: 楷体_GB2312; font-size: 19px">1</span
          ><span style="font-family: 楷体_GB2312; font-size: 19px">3</span
          ><span style="font-family: 楷体_GB2312; font-size: 19px"
            >、乙方确保</span
          ><span style="font-family: 楷体_GB2312; font-size: 19px"
            >认真贯彻落实省市区关于疫情防控安排部署及工作提醒，组织开展教育培训，切实增强</span
          ><span style="font-family: 楷体_GB2312; font-size: 19px"
            >工作人员的</span
          ><span style="font-family: 楷体_GB2312; font-size: 19px"
            >责任意识和安全意识。若存在故意隐瞒、谎报、编造、乱报疫情相关信息，或者有其他妨碍疫情防控工作行为的，</span
          ><span style="font-family: 楷体_GB2312; font-size: 19px">并由此</span
          ><span style="font-family: 楷体_GB2312; font-size: 19px"
            >产生的一切责任由乙方自行承担。</span
          >
        </p>
        <p style="text-indent: 37px; line-height: 31px">
          <span style="font-family: 楷体_GB2312; font-size: 19px"
            >六、违约责任</span
          >
        </p>
        <p style="text-indent: 37px; line-height: 31px">
          <span style="font-family: 楷体_GB2312; font-size: 19px"
            >1、 乙方未经甲方书面许可，擅自将本合同项下的</span
          ><span style="font-family: 楷体_GB2312; font-size: 19px">材料</span
          ><span style="font-family: 楷体_GB2312; font-size: 19px">运输</span
          ><span style="font-family: 楷体_GB2312; font-size: 19px">工作</span
          ><span style="font-family: 楷体_GB2312; font-size: 19px"
            >转交由第三方承办的，甲方有权解除合同，乙方除应退还已收取的费用外，还应当支付</span
          ><span style="font-family: 楷体_GB2312; font-size: 19px">运输</span
          ><span style="font-family: 楷体_GB2312; font-size: 19px">总额</span
          ><span style="font-family: 楷体_GB2312; font-size: 19px">30</span
          ><span style="font-family: 楷体_GB2312; font-size: 19px"
            >&nbsp;<span style="font-family: 楷体_GB2312"
              >%的违约金。</span
            ></span
          >
        </p>
        <p style="text-indent: 37px; line-height: 31px">
          <span style="font-family: 楷体_GB2312; font-size: 19px">2、</span
          ><span style="font-family: 楷体_GB2312; font-size: 19px"
            >乙方未按甲方指定时间、地点完成运输工作的</span
          ><span style="font-family: 楷体_GB2312; font-size: 19px">，</span
          ><span style="font-family: 楷体_GB2312; font-size: 19px"
            >应当向甲方支付</span
          ><span style="font-family: 楷体_GB2312; font-size: 19px">运输费</span
          ><span style="font-family: 楷体_GB2312; font-size: 19px">总额</span
          ><span style="font-family: 楷体_GB2312; font-size: 19px">30</span
          ><span style="font-family: 楷体_GB2312; font-size: 19px"
            >%的违约金。</span
          >
        </p>
        <p style="text-indent: 37px; line-height: 31px">
          <span style="font-family: 楷体_GB2312; font-size: 19px">3、</span
          ><span style="font-family: 楷体_GB2312; font-size: 19px"
            >若乙方违约给甲方造成经济损失，约定的违约金低于甲方损失的，不足部分由乙方据实赔偿或甲方从应付款中直接抵扣，不足以抵扣的部分，乙方仍应承担，并承担甲方因追究乙方违约责任而产生的所有费用，包括但不限于通知公告费用、律师咨询代理费用、公证费用等。</span
          >
        </p>
        <p style="text-indent: 37px; line-height: 31px">
          <span style="font-family: 楷体_GB2312; font-size: 19px">七</span
          ><span style="font-family: 楷体_GB2312; font-size: 19px"
            >、其他约定</span
          >
        </p>
        <p style="text-indent: 37px; line-height: 31px">
          <span style="font-family: 楷体_GB2312; font-size: 19px"
            >1、若本协议发生争议,双方应协商解决</span
          ><span style="font-family: 楷体_GB2312; font-size: 19px">，</span
          ><span style="font-family: 楷体_GB2312; font-size: 19px"
            >协商不成的，</span
          ><span style="font-family: 楷体_GB2312; font-size: 19px"
            >任何一方均有权向甲方所在地人民法院提起诉讼</span
          ><span style="font-family: 楷体_GB2312; font-size: 19px">。</span>
        </p>
        <p style="text-indent: 37px; line-height: 31px">
          <span style="font-family: 楷体_GB2312; font-size: 19px">2、</span
          ><span style="font-family: 楷体_GB2312; font-size: 19px"
            ><span style="font-family: 楷体_GB2312"
              >此合同履行过程中，因不可抗力导致本合同无法履行的，遭受不可抗力方可以免除责任；但遭受该不可抗力事件的一方，应在事件发生后</span
            ><span style="font-family: 楷体_GB2312"
              >5日内通知对方。发生不可抗力事件时，双方应尽一切合理的努力，使不可抗力对履行合同造成的任何延误或损失减少到最小。</span
            ></span
          >
        </p>
        <p style="text-indent: 37px; line-height: 31px">
          <span style="font-family: 楷体_GB2312; font-size: 19px">3</span
          ><span style="font-family: 楷体_GB2312; font-size: 19px"
            ><span style="font-family: 楷体_GB2312">、未尽事宜</span
            ><span style="font-family: 楷体_GB2312"
              >,经双方协商一致可另行补充约定</span
            ></span
          ><span style="font-family: 楷体_GB2312; font-size: 19px">，</span
          ><span style="font-family: 楷体_GB2312; font-size: 19px">签订的</span
          ><span style="font-family: 楷体_GB2312; font-size: 19px"
            >补充合同</span
          ><span style="font-family: 楷体_GB2312; font-size: 19px"
            >与本合同具有同等法律效力。</span
          >
        </p>
        <p style="text-indent: 37px; line-height: 31px">
          <span style="font-family: 楷体_GB2312; font-size: 19px">4</span
          ><span style="font-family: 楷体_GB2312; font-size: 19px"
            >、本协议自甲乙双方</span
          ><span style="font-family: 楷体_GB2312; font-size: 19px"
            >法定代表人</span
          ><span style="font-family: 楷体_GB2312; font-size: 19px">签字</span
          ><span style="font-family: 楷体_GB2312; font-size: 19px">并加</span
          ><span style="font-family: 楷体_GB2312; font-size: 19px">盖</span
          ><span style="font-family: 楷体_GB2312; font-size: 19px">公</span
          ><span style="font-family: 楷体_GB2312; font-size: 19px"
            >章之日起生效。协议有效期以甲方工程项目的需要为标准，乙方不得以任何理由单方面中止协议。</span
          >
        </p>
        <p style="text-indent: 37px; line-height: 31px">
          <span style="font-family: 楷体_GB2312; font-size: 19px">5</span
          ><span style="font-family: 楷体_GB2312; font-size: 19px"
            >、本协议一式<span
              style="
                border-bottom: 1px solid rgb(44, 62, 80);
                outline: 0;
                min-width: 1cm;
                display: inline-block;
                text-indent: 5px;
              "
              :contenteditable="dialogForm.approveStatus != 2&&dialogForm.approveStatus != 3"
              class="contractTotal"
              >{{ detailForm.contractTotal }}</span
            >份，甲方<span
              style="
                border-bottom: 1px solid rgb(44, 62, 80);
                outline: 0;
                min-width: 1cm;
                display: inline-block;
                text-indent: 5px;
              "
              :contenteditable="dialogForm.approveStatus != 2&&dialogForm.approveStatus != 3"
              class="contractAnum"
              >{{ detailForm.contractAnum }}</span
            >份，乙方<span
              style="
                border-bottom: 1px solid rgb(44, 62, 80);
                outline: 0;
                min-width: 1cm;
                display: inline-block;
                text-indent: 5px;
              "
              :contenteditable="dialogForm.approveStatus != 2&&dialogForm.approveStatus != 3"
              class="contractBnum"
              >{{ detailForm.contractBnum }}</span
            >,具有同等法律效力。</span
          >
        </p>
        <p style="text-indent: 37px; line-height: 31px">
          <span style="font-family: 楷体_GB2312; font-size: 19px">&nbsp;</span>
        </p>
        <p style="text-indent: 37px; line-height: 31px">
          <span style="font-family: 楷体_GB2312; font-size: 19px">&nbsp;</span>
        </p>
        <p style="text-indent: 37px; line-height: 31px">
          <span style="font-family: 楷体_GB2312; font-size: 19px"
            ><span style="font-family: 楷体_GB2312">特别条款</span
            ><span style="font-family: 楷体_GB2312">:</span></span
          >
        </p>
        <p style="text-indent: 37px; line-height: 31px">
          <span style="font-family: 楷体_GB2312; font-size: 19px"
            ><span style="font-family: 楷体_GB2312"
              >乙方每次收取运输款时，需出具合法的等额发票给甲方，否则，甲方不予付款或追回已付款。如乙方提供给甲方的发票被税务部门查证为假发票，乙方除承担行政罚款、民事责任、刑事犯罪等一切责任外，还须向甲方支付不低于涉案发票金额</span
            ><span style="font-family: 楷体_GB2312"
              >20%的违约金，同时向甲方重新提供税务部门出具的合法发票。</span
            ></span
          >
        </p>
        <p style="text-indent: 37px; line-height: 20px">
          <span style="font-family: 楷体_GB2312; font-size: 19px">&nbsp;</span>
        </p>
        <table width="100%" style="border-collapse: collapse">
          <tbody>
            <tr style="height: 100px;font-family: 楷体_GB2312;page-break-inside: avoid;" class="firstRow">
              <td
                width="284"
                style="
                  border-width: 1px;
                  border-color: windowtext;
                  padding: 0px 7px;
                  border-style: solid;
                "
              >
                <p
                  style="
                    text-align: justify;
                    font-size: 14px;
                    line-height: 31px;
                  "
                >
                  <span style="font-size: 19px; font-family: 楷体_GB2312"
                    >甲 方：（公 章）：</span
                  ><span
                    style="font-size: 19px"
                    class="partA_gongzhang"
                    :contenteditable="
                      dialogForm.approveStatus != 2 &&
                      dialogForm.approveStatus != 3
                    "
                    >{{ detailForm.partA_gongzhang }}</span
                  >
                </p>
                <p style="line-height: 31px;font-family: 楷体_GB2312; font-size: 19px">
                  <span>法定代表人：（签字）：</span
                  ><span
                    style="font-size: 19px"
                    class="partA_fdsign"
                    :contenteditable="
                      dialogForm.approveStatus != 2 &&
                      dialogForm.approveStatus != 3
                    "
                    >{{ detailForm.partA_fdsign }}</span
                  >
                </p>
                <p
                  style="
                    text-align: justify;
                    font-size: 19px;
                    line-height: 31px;
                  "
                >
                  <span style="font-size: 19px; font-family: 楷体_GB2312"
                    >授权委托人（签字）：</span
                  ><span
                    style="font-size: 19px"
                    class="partA_sign"
                    :contenteditable="
                      dialogForm.approveStatus != 2 &&
                      dialogForm.approveStatus != 3
                    "
                    >{{ detailForm.partA_sign }}</span
                  >
                </p>
                <p
                  style="
                    text-align: justify;
                    font-size: 19px;
                    line-height: 31px;
                  "
                >
                  <span>电话：</span>
                  <span
                    class="partA_phone"
                    :contenteditable="
                      dialogForm.approveStatus != 2 &&
                      dialogForm.approveStatus != 3
                    "
                    >{{ detailForm.partA_phone }}</span
                  >
                </p>
                <p
                  style="
                    text-align: justify;
                    font-size: 19px;
                    line-height: 31px;
                  "
                >
                  <span style="font-size: 19px; font-family: 楷体_GB2312"
                    >账户信息：</span
                  ><span
                    style="font-size: 19px"
                    class="partA_account"
                    :contenteditable="
                      dialogForm.approveStatus != 2 &&
                      dialogForm.approveStatus != 3
                    "
                    >{{ detailForm.partA_account }}</span
                  >
                </p>
                <p
                  style="
                    text-align: justify;
                    font-size: 14px;
                    line-height: 31px;
                  "
                >
                  <span style="font-size: 19px; font-family: 楷体_GB2312"
                    >&nbsp;</span
                  ><span
                    style="text-decoration: underline"
                  ></span>
                </p>
                <p
                  style="
                    text-align: justify;
                    font-size: 14px;
                    line-height: 31px;
                  "
                >
                  <span style="font-size: 19px; font-family: 楷体_GB2312"
                    >通信地址：</span
                  ><span
                    style="font-size: 19px"
                    class="partA_ads"
                    :contenteditable="
                      dialogForm.approveStatus != 2 &&
                      dialogForm.approveStatus != 3
                    "
                    >{{ detailForm.partA_ads }}</span
                  >
                </p>
                <p
                  style="
                    text-align: justify;
                    font-size: 14px;
                    line-height: 31px;
                  "
                >
                  <span style="font-size: 19px; font-family: 楷体_GB2312"
                    >传真：</span
                  ><span
                    style="font-size: 19px"
                    class="partA_fix"
                    :contenteditable="
                      dialogForm.approveStatus != 2 &&
                      dialogForm.approveStatus != 3
                    "
                    >{{ detailForm.partA_fix }}</span
                  >
                </p>
              </td>
              <td
                width="285"
                style="
                  border-top-width: 1px;
                  border-top-color: windowtext;
                  border-right-width: 1px;
                  border-right-color: windowtext;
                  border-bottom-width: 1px;
                  border-bottom-color: windowtext;
                  border-left: 0;
                  padding: 0px 7px;
                  border-style: solid;
                "
              >
                <p
                  style="
                    text-align: justify;
                    font-size: 14px;
                    line-height: 31px;
                  "
                >
                  <span style="font-size: 19px; font-family: 楷体_GB2312"
                    >乙 方（公 章）：</span
                  ><span
                    style="font-size: 19px"
                    class="partB_gongzhang"
                    :contenteditable="
                      dialogForm.approveStatus != 2 &&
                      dialogForm.approveStatus != 3
                    "
                    >{{ detailForm.partB_gongzhang }}</span
                  >
                </p>
                <p style="line-height: 31px;font-family: 楷体_GB2312; font-size: 19px">
                  <span>法定代表人：（签字）：</span
                  ><span
                    style="font-size: 19px"
                    class="partB_fdsign"
                    :contenteditable="
                      dialogForm.approveStatus != 2 &&
                      dialogForm.approveStatus != 3
                    "
                    >{{ detailForm.partB_fdsign }}</span
                  >
                </p>
                <p
                  style="
                    text-align: justify;
                    font-size: 19px;
                    line-height: 31px;
                    font-family: 楷体_GB2312
                  "
                >
                  <span>授权委托人（签字）：</span
                  ><span
                    style="font-size: 19px"
                    class="partB_sign"
                    :contenteditable="
                      dialogForm.approveStatus != 2 &&
                      dialogForm.approveStatus != 3
                    "
                    >{{ detailForm.partB_sign }}</span
                  >
                </p>
                <p
                  style="
                    text-align: justify;
                    font-size: 19px;
                    line-height: 31px;
                  "
                >
                  <span>电话：</span>
                  <span
                    class="partB_phone"
                    :contenteditable="
                      dialogForm.approveStatus != 2 &&
                      dialogForm.approveStatus != 3
                    "
                    >{{ detailForm.partB_phone }}</span
                  >
                </p>
                <p
                  style="
                    text-align: justify;
                    font-size: 14px;
                    line-height: 31px;
                  "
                >
                  <span style="font-size: 19px; font-family: 楷体_GB2312"
                    >&nbsp;</span
                  ><span
                    style="text-decoration: underline"
                  ></span>
                </p>
                <p
                  style="
                    text-align: justify;
                    font-size: 14px;
                    line-height: 31px;
                  "
                >
                  <span style="font-size: 19px; font-family: 楷体_GB2312"
                    >&nbsp;</span
                  ><span style="font-size: 19px" ></span>
                </p>
                <p
                  style="
                    text-align: justify;
                    font-size: 14px;
                    line-height: 31px;
                  "
                >
                  <span style="font-size: 19px; font-family: 楷体_GB2312"
                    >通讯地址：</span
                  ><span
                    style="font-size: 19px"
                    class="partB_ads"
                    :contenteditable="
                      dialogForm.approveStatus != 2 &&
                      dialogForm.approveStatus != 3
                    "
                    >{{ detailForm.partB_ads }}</span
                  >
                </p>
                <p
                  style="
                    text-align: justify;
                    font-size: 14px;
                    line-height: 31px;
                  "
                >
                  <span style="font-size: 19px; font-family: 楷体_GB2312"
                    >传真：</span
                  ><span
                    style="font-size: 19px"
                    class="partB_fix"
                    :contenteditable="
                      dialogForm.approveStatus != 2 &&
                      dialogForm.approveStatus != 3
                    "
                    >{{ detailForm.partB_fix }}</span
                  >
                </p>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="printWrap" v-show="false">
        <div
          v-html="transportContent"
          class="mainHtml"
          id="printtransportContent"
        ></div>
      </div>
    </div>
    <setWatermarkDialog
      ref="setWatermarking"
      @setWaterMarkFun="setWaterMarkFun"
    ></setWatermarkDialog>
  </div>
</template>

<script>
import {
  getServiceContractDetailService, //获取合同填充内容
} from "@/services/allContractServices";
import printJS from "print-js";
import {mixins} from '@/page/contract/template/mixin.js';
import setWatermarkDialog from "../../commonCell/setWatermarkDialog.vue";
import {addPageNum} from "../common.js"
import { addPageNumCustom } from "../common.js";

export default {
  name: "transportContract",
  mixins: [mixins],
  components: {
    setWatermarkDialog,
  },
  data() {
    return {
      transportContent: "", //富文本编辑器内容
      watermark: [''],
      saveflag: false,
      detailForm: { ...this.dialogForm },
      inputPages: "",
      inputHeight: 1010,
      inputPosx: 37,
    };
  },
  // mounted() {
  //   if (this.subServiceContractId) {
  //     this.getsubServiceContractDetail(this.subServiceContractId);
  //   }
  //   this.transportContent = this.$refs.HTMLtransportContent.innerHTML;
  //   this.transportContent = document.getElementById(
  //     "HTMLtransportContent"
  //   ).innerHTML;
  // },
  methods: {
    //获取一条劳务合同信息
    getsubServiceContractDetail(id) {
      if (!id) return;
      let param = {};
      param.id = id;
      getServiceContractDetailService(param)
        .then((res) => {
          if (res.code == 10000000) {
            let data = {};
            if (res.data.subContractPrintVO) {
              data = res.data.subContractPrintVO;
              this.watermark = res.data.subContractPrintVO.watermark || [''];
              if (data.content) {
                this.saveflag = true;
                this.detailForm = JSON.parse(data.content);
              } else {
                this.detailForm = { ...this.dialogForm };
              }
            }
          } else if (res.code >= 20000000) {
            this.$alert(res.msg, "提示", {
              confirmButtonText: "确定",
            });
          } else {
            this.$alert("系统异常", "提示", {
              confirmButtonText: "确定",
            });
          }
          this.loading=false;
        })
        .catch((error) => {
          this.$alert(error, "提示", {
            confirmButtonText: "确定",
          });
          this.loading=false;
        });
    },
    saveContractA() {
      this.saveCommon('transportContract')
    },
    getValues() {
      // let Id = document.getElementById("HTMLtransportContent");
      let Id = document.getElementsByClassName(this.printClass)[0];
      this.detailForm.serialNumber =
        Id.getElementsByClassName("serialNumber")[0].innerText.trim();
      this.detailForm.partyA =
        Id.getElementsByClassName("partyA")[0].innerText.trim();
      this.detailForm.partyB =
        Id.getElementsByClassName("partyB")[0].innerText.trim();
      this.detailForm.project =
        Id.getElementsByClassName("project")[0].innerText.trim();
      Id.getElementsByClassName("project")[0].innerHTML = this.detailForm.project;
      this.detailForm.projectName =
        Id.getElementsByClassName("projectName")[0].innerText.trim();
      this.detailForm.signPlace =
        Id.getElementsByClassName("signPlace")[0].innerText.trim();
      Id.getElementsByClassName("signPlace")[0].innerHTML =
        this.detailForm.signPlace;
      this.detailForm.signDate =
        Id.getElementsByClassName("signDate")[0].innerText.trim();
      Id.getElementsByClassName("signDate")[0].innerHTML =
        this.detailForm.signDate;
      this.detailForm.contents =
        Id.getElementsByClassName("contents")[0].innerText.trim();

      this.detailForm.limitDate =
        Id.getElementsByClassName("limitDate")[0].innerText.trim();
      this.detailForm.price1 =
        Id.getElementsByClassName("price1")[0].innerText.trim();
        
      this.detailForm.price2 =
        Id.getElementsByClassName("price2")[0].innerText.trim();
      this.detailForm.price3 =
        Id.getElementsByClassName("price3")[0].innerText.trim();
      this.detailForm.price4 =
        Id.getElementsByClassName("price4")[0].innerText.trim();
        this.detailForm.price5 =
        Id.getElementsByClassName("price5")[0].innerText.trim();
      this.detailForm.price6 =
        Id.getElementsByClassName("price6")[0].innerText.trim();
      this.detailForm.price7 =
        Id.getElementsByClassName("price7")[0].innerText.trim();
      this.detailForm.price8 =
        Id.getElementsByClassName("price8")[0].innerText.trim();
        this.detailForm.price9 =
        Id.getElementsByClassName("price9")[0].innerText.trim();
      this.detailForm.price10 =
        Id.getElementsByClassName("price10")[0].innerText.trim();

      this.detailForm.contractTotal =
        Id.getElementsByClassName("contractTotal")[0].innerText.trim();
      this.detailForm.contractAnum =
        Id.getElementsByClassName("contractAnum")[0].innerText.trim();
      this.detailForm.contractBnum =
        Id.getElementsByClassName("contractBnum")[0].innerText.trim();

        Id.getElementsByClassName("contents")[0].innerText= this.detailForm.contents;
        Id.getElementsByClassName("limitDate")[0].innerText= this.detailForm.limitDate;
        Id.getElementsByClassName("price1")[0].innerText= this.detailForm.price1;
        Id.getElementsByClassName("price2")[0].innerText= this.detailForm.price2;
        Id.getElementsByClassName("price3")[0].innerText= this.detailForm.price3;
        Id.getElementsByClassName("price4")[0].innerText= this.detailForm.price4;
        Id.getElementsByClassName("price5")[0].innerText= this.detailForm.price5;
        Id.getElementsByClassName("price6")[0].innerText= this.detailForm.price6;
        Id.getElementsByClassName("price7")[0].innerText= this.detailForm.price7;
        Id.getElementsByClassName("price8")[0].innerText= this.detailForm.price8;
        Id.getElementsByClassName("price9")[0].innerText= this.detailForm.price9;
        Id.getElementsByClassName("price10")[0].innerText= this.detailForm.price10;
        Id.getElementsByClassName("contractTotal")[0].innerText= this.detailForm.contractTotal;
        Id.getElementsByClassName("contractAnum")[0].innerText= this.detailForm.contractAnum;
        Id.getElementsByClassName("contractBnum")[0].innerText= this.detailForm.contractBnum;

        this.detailForm.partA_gongzhang =
        Id.getElementsByClassName("partA_gongzhang")[0].innerText;
      Id.getElementsByClassName("partA_gongzhang")[0].innerHTML =
        this.detailForm.partA_gongzhang;
      this.detailForm.partA_sign =
        Id.getElementsByClassName("partA_sign")[0].innerText;
      Id.getElementsByClassName("partA_sign")[0].innerHTML =
        this.detailForm.partA_sign;
        this.detailForm.partA_fdsign =
        Id.getElementsByClassName("partA_fdsign")[0].innerText;
      Id.getElementsByClassName("partA_fdsign")[0].innerHTML =
        this.detailForm.partA_fdsign;
      this.detailForm.partA_phone =
        Id.getElementsByClassName("partA_phone")[0].innerText;
      Id.getElementsByClassName("partA_phone")[0].innerHTML =
        this.detailForm.partA_phone;
      this.detailForm.partA_account =
        Id.getElementsByClassName("partA_account")[0].innerText;
      Id.getElementsByClassName("partA_account")[0].innerHTML =
        this.detailForm.partA_account;
      this.detailForm.partA_ads =
        Id.getElementsByClassName("partA_ads")[0].innerText;
      Id.getElementsByClassName("partA_ads")[0].innerHTML =
        this.detailForm.partA_ads;
      this.detailForm.partA_fix =
        Id.getElementsByClassName("partA_fix")[0].innerText;
      Id.getElementsByClassName("partA_fix")[0].innerHTML =
        this.detailForm.partA_fix;

      this.detailForm.partB_gongzhang =
        Id.getElementsByClassName("partB_gongzhang")[0].innerText;
      Id.getElementsByClassName("partB_gongzhang")[0].innerHTML =
        this.detailForm.partB_gongzhang;
      this.detailForm.partB_sign =
        Id.getElementsByClassName("partB_sign")[0].innerText;
      Id.getElementsByClassName("partB_sign")[0].innerHTML =
        this.detailForm.partB_sign;
        this.detailForm.partB_fdsign =
        Id.getElementsByClassName("partB_fdsign")[0].innerText;
      Id.getElementsByClassName("partB_fdsign")[0].innerHTML =
        this.detailForm.partB_fdsign;
      this.detailForm.partB_phone =
        Id.getElementsByClassName("partB_phone")[0].innerText;
      Id.getElementsByClassName("partB_phone")[0].innerHTML =
        this.detailForm.partB_phone;
      this.detailForm.partB_ads =
        Id.getElementsByClassName("partB_ads")[0].innerText;
      Id.getElementsByClassName("partB_ads")[0].innerHTML =
        this.detailForm.partB_ads;

      this.detailForm.partB_fix =
        Id.getElementsByClassName("partB_fix")[0].innerText;
      Id.getElementsByClassName("partB_fix")[0].innerHTML =
        this.detailForm.partB_fix;
    },
    
    //打印当前合同
    PrintContractD() {
      if (this.dialogForm.approveStatus != 3) {
        this.$alert("合同尚未通过审核，无法打印", "提示", {
          confirmButtonText: "确定",
        });
        return;
      }
      // let Id = document.getElementById("HTMLtransportContent");
      let Id = document.getElementsByClassName(this.printClass)[0];
      let elementsToRemove = Id.querySelectorAll(".page-num");
      elementsToRemove.forEach(function (element) {
        element.parentNode.removeChild(element);
      });
      //addPageNum(Id,0,'transportContent');
      addPageNumCustom(Id, 0, "transportContent", this.inputPages, this.inputHeight, this.inputPosx);

      this.$set(
        this,
        "transportContent",
        this.$refs.HTMLtransportContent.innerHTML
      );
      this.$nextTick(() => {
        printJS({
          printable: "printtransportContent",
          type: "html",
          targetStyles: ["*"],
          ignoreElements: ["no-print", "bc", "gb"],
          scanStyles: false,
          style: `@page { size: auto; margin:10mm } p{line-height: 31px} .HTMLtransportContract1 {background: url("data:image/svg+xml,%3Csvg width='200' height='200' xmlns='http://www.w3.org/2000/svg'%3E%3Ctext x='50%25' y='50%25' font-size='14' fill-opacity='0.3' text-anchor='middle' dominant-baseline='middle' transform='rotate(-35, 100 100)'%3E${this.watermark.join(
            ";"
          )}%3C/text%3E%3C/svg%3E");
}`,
        });
      });
    },
    //设置水印
    setWatermark() {
      this.$refs.setWatermarking.showwaterMarkDialog(
        this.subServiceContractId,
        this.watermark
      );
    },
    setWaterMarkFun(val) {
      this.watermark = val;
      let param = {
        warterMark: this.watermark,
        version: "1.0",
        flag: 2,
      };
      this.$emit("savePrintInfo", param);
    },
  },
};
</script>

<style>
#HTMLtransportContent {
  /* position: relative; */
  width: 20.1cm;
  padding: 0 10px;
  margin-top: 58px;
  box-shadow: 0px 4px 12px 2px #bbb;
}

p{line-height: 31px}
.buttons{
  width: 22cm;
    height: 56px;
    position: fixed;
    top: 90px;
    background: white;
    z-index: 9;
}


.printWrap {
  width: 21cm;
  margin: 30px auto;
  padding: 5mm;
  box-shadow: 0 0 0.5cm rgba(0, 0, 0, 0.5);
}

.mainHtml {
  width: 21cm;
}
</style>
